import React from "react";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Row,
  Spin,
  Table,
  Tooltip as Tooltip_antd,
} from "antd";
import { Bar, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "./style.css";
import moment from "moment";
import {
  DownloadOutlined,
  QuestionCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Funnel } from "@ant-design/charts";
// import { Funnel } from '@ant-design/plots';

const { RangePicker } = DatePicker;

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  ChartDataLabels,
  Title,
  Tooltip,
  Legend
);

const PositionRecruitment = ({ dataReport }) => {
  const generateLabels = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_rect.length == 0) {
      return [];
    }
    const data_labels =
      dataReport.result_rect.length > 0
        ? dataReport.result_rect.map((item) => item["rec_position"])
        : [{}];

    return data_labels;
  };
  const data_cv_all = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_rect.length == 0) {
      return [];
    }

    const value_labels = dataReport.result_rect.map(
      (item) => item["number_cv_all"]
    );
    return value_labels;
  };

  const data_quantity = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_rect.length == 0) {
      return [];
    }

    const value_labels = dataReport.result_rect.map((item) => item["quantity"]);
    return value_labels;
  };
  const data_number_cv_pass = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_rect.length == 0) {
      return [];
    }

    const value_labels = dataReport.result_rect.map(
      (item) => item["number_cv_pass"]
    );
    return value_labels;
  };

  const data = {
    labels: generateLabels(dataReport),
    datasets: [
      {
        label: "Số lượng CV",
        data: data_cv_all(dataReport),
        backgroundColor: "rgba(64, 175, 60, 0.2)",
        borderColor: "rgb(64, 175, 60)",
        borderWidth: 1,
        barThickness: 35, // Độ dày cố định của cột
      },
      {
        label: "Số lượng yêu cầu",
        data: data_quantity(dataReport),
        backgroundColor: "rgba(60, 175, 175, 0.2)",
        borderColor: "rgb(60, 175, 175)",
        borderWidth: 1,
        barThickness: 35, // Độ dày cố định của cột
      },
      {
        label: "Số lượng nhận việc",
        data: data_number_cv_pass(dataReport),
        backgroundColor: "rgba(255, 205, 86, 0.2)",
        borderColor: "rgb(255, 205, 86)",
        borderWidth: 1,
        barThickness: 35, // Độ dày cố định của cột
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: true, // Tắt hiển thị tên và màu
        position: "top",
        align: "end", // Căn về phía bên phải
        //  labels: {
        //   boxWidth: 20, // Kích thước hình vuông màu trong legend
        //   padding: 10, // Khoảng cách giữa các nhãn
        // },
      },
      centerText: {
        display: false, // Set to false to not display the center text
      },
      datalabels: {
        // label:'Số lượng ứng viên',
        display: false, //tắt hiển thị ChartDataLabels
      },
      title: {
        display: true,
        text: "Vị trí tuyển dụng",
        font: {
          size: 18,
          weight: "bold",
        },
        color: "#333",
      },
    },
    maintainAspectRatio: false, // Vô hiệu hóa tỷ lệ khung hình
    responsive: true,
    scales: {
      x: {
        stacked: false, // Hiển thị các cột cạnh nhau
      },
      y: {
        title: {
          display: true,
          text: "Số lượng ứng viên", // Name of x-axis
        },
        beginAtZero: true,
        stacked: false,
        suggestedMax: 30, // Giá trị gợi ý tối đa
        ticks: {
          callback: function (value, index, values) {
            if (index === values.length - 1) {
              return `${value}`;
            }

            return value;
          },
        },
      },
    },
  };

  return (
    <>
      <Bar data={data} options={options} />
    </>
  );
};

const DepartmentRecruitment = ({ dataReport }) => {
  const generateLabels = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_department.length == 0) {
      return [];
    }
    const data_labels =
      dataReport.result_department.length > 0
        ? dataReport.result_department.map((item) => item["department_recruited"])
        : [{}];

    return data_labels;
  };
  const data_cv_all = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_department.length == 0) {
      return [];
    }

    const value_labels = dataReport.result_department.map(
      (item) => item["number_cv_all"]
    );
    return value_labels;
  };

  const data_quantity = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_department.length == 0) {
      return [];
    }

    const value_labels = dataReport.result_department.map((item) => item["quantity"]);
    return value_labels;
  };
  const data_number_cv_pass = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_department.length == 0) {
      return [];
    }

    const value_labels = dataReport.result_department.map(
      (item) => item["number_cv_pass"]
    );
    return value_labels;
  };

  const data = {
    labels: generateLabels(dataReport),
    datasets: [
      {
        label: "Số lượng CV",
        data: data_cv_all(dataReport),
        backgroundColor: "rgba(64, 175, 60, 0.2)",
        borderColor: "rgb(64, 175, 60)",
        borderWidth: 1,
        barThickness: 35, // Độ dày cố định của cột
      },
      {
        label: "Số lượng yêu cầu",
        data: data_quantity(dataReport),
        backgroundColor: "rgba(60, 175, 175, 0.2)",
        borderColor: "rgb(60, 175, 175)",
        borderWidth: 1,
        barThickness: 35, // Độ dày cố định của cột
      },
      {
        label: "Số lượng nhận việc",
        data: data_number_cv_pass(dataReport),
        backgroundColor: "rgba(255, 205, 86, 0.2)",
        borderColor: "rgb(255, 205, 86)",
        borderWidth: 1,
        barThickness: 35, // Độ dày cố định của cột
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: true, // Tắt hiển thị tên và màu
        position: "top",
        align: "end", // Căn về phía bên phải
        //  labels: {
        //   boxWidth: 20, // Kích thước hình vuông màu trong legend
        //   padding: 10, // Khoảng cách giữa các nhãn
        // },
      },
      centerText: {
        display: false, // Set to false to not display the center text
      },
      datalabels: {
        // label:'Số lượng ứng viên',
        display: false, //tắt hiển thị ChartDataLabels
      },
      title: {
        display: true,
        text: "Bộ phận tuyển dụng",
        font: {
          size: 18,
          weight: "bold",
        },
        color: "#333",
      },
    },
    maintainAspectRatio: false, // Vô hiệu hóa tỷ lệ khung hình
    responsive: true,
    scales: {
      x: {
        stacked: false, // Hiển thị các cột cạnh nhau
      },
      y: {
        title: {
          display: true,
          text: "Số lượng ứng viên", // Name of x-axis
        },
        beginAtZero: true,
        stacked: false,
        suggestedMax: 30, // Giá trị gợi ý tối đa
        ticks: {
          callback: function (value, index, values) {
            if (index === values.length - 1) {
              return `${value}`;
            }

            return value;
          },
        },
      },
    },
  };

  return (
    <>
      <Bar data={data} options={options} />
    </>
  );
};

const UserReceivedRecruitment = ({ dataReport }) => {
  const generateLabels = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_hr.length == 0) {
      return [];
    }
    const data_labels =
      dataReport.result_hr.length > 0
        ? dataReport.result_hr.map((item) => item["username"])
        : [{}];

    return data_labels;
  };

  const data_cv_all = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_hr.length == 0) {
      return [];
    }

    const value_labels = dataReport.result_hr.map(
      (item) => item["number_cv_all"]
    );
    return value_labels;
  };

  const data_quantity = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_hr.length == 0) {
      return [];
    }

    const value_labels = dataReport.result_hr.map((item) => item["quantity"]);
    return value_labels;
  };
  const data_number_cv_pass = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_hr.length == 0) {
      return [];
    }

    const value_labels = dataReport.result_hr.map(
      (item) => item["number_cv_pass"]
    );
    return value_labels;
  };

  const data = {
    labels: generateLabels(dataReport),
    datasets: [
      {
        label: "Số lượng CV",
        data: data_cv_all(dataReport),
        backgroundColor: "rgba(64, 175, 60, 0.2)",
        borderColor: "rgb(64, 175, 60)",
        borderWidth: 1,
        barThickness: 35, // Độ dày cố định của cột
      },
      {
        label: "Số lượng yêu cầu",
        data: data_quantity(dataReport),
        backgroundColor: "rgba(60, 175, 175, 0.2)",
        borderColor: "rgb(60, 175, 175)",
        borderWidth: 1,
        barThickness: 35, // Độ dày cố định của cột
      },
      {
        label: "Số lượng đã nhận việc",
        data: data_number_cv_pass(dataReport),
        backgroundColor: "rgba(255, 205, 86, 0.2)",
        borderColor: "rgb(255, 205, 86)",
        borderWidth: 1,
        barThickness: 35, // Độ dày cố định của cột
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: true, // Tắt hiển thị tên và màu
        position: "top",
        align: "end", // Căn về phía bên phải
        //  labels: {
        //   boxWidth: 20, // Kích thước hình vuông màu trong legend
        //   padding: 10, // Khoảng cách giữa các nhãn
        // },
      },
      centerText: {
        display: false, // Set to false to not display the center text
      },
      datalabels: {
        // label:'Số lượng ứng viên',
        display: false, //tắt hiển thị ChartDataLabels
      },
      title: {
        display: true,
        text: "Người phụ trách tuyển dụng",
        font: {
          size: 18,
          weight: "bold",
        },
        color: "#333",
      },
    },
    maintainAspectRatio: false, // Vô hiệu hóa tỷ lệ khung hình
    responsive: true,
    scales: {
      x: {
        stacked: false, // Hiển thị các cột cạnh nhau
      },
      y: {
        title: {
          display: true,
          text: "Số lượng ứng viên", // Name of x-axis
        },
        beginAtZero: true,
        stacked: false,
        suggestedMax: 30, // Giá trị gợi ý tối đa
        ticks: {
          callback: function (value, index, values) {
            if (index === values.length - 1) {
              return `${value}`;
            }

            return value;
          },
        },
      },
    },
  };

  return (
    <>
      <Bar data={data} options={options} />
    </>
  );
};

const TimeRecruitment = ({ dataReport }) => {
  const generateLabels = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_time_recruitment.length == 0) {
      return [];
    }
    const data_labels =
      dataReport.result_time_recruitment.length > 0
        ? dataReport.result_time_recruitment.map((item) => item["rec_position"])
        : [{}];

    return data_labels;
  };

  const data_rate_pass = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_time_recruitment.length == 0) {
      return [];
    }

    const value_labels = dataReport.result_time_recruitment.map(
      (item) => item["rate_pass"]
    );
    return value_labels;
  };

  const data = {
    labels: generateLabels(dataReport),
    datasets: [
      {
        label: "Trung bình tuyển dụng",
        data: data_rate_pass(dataReport),
        backgroundColor: "rgba(64, 175, 60, 0.2)",
        borderColor: "rgb(64, 175, 60)",
        borderWidth: 1,
        barThickness: 35, // Độ dày cố định của cột
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: true, // Tắt hiển thị tên và màu
        position: "top",
        align: "end", // Căn về phía bên phải
        //  labels: {
        //   boxWidth: 20, // Kích thước hình vuông màu trong legend
        //   padding: 10, // Khoảng cách giữa các nhãn
        // },
      },
      centerText: {
        display: false, // Set to false to not display the center text
      },
      datalabels: {
        // label:'Số lượng ứng viên',
        display: false, //tắt hiển thị ChartDataLabels
      },
      title: {
        display: true,
        text: "Thời gian tuyển dụng",
        font: {
          size: 18,
          weight: "bold",
        },
        color: "#333",
      },
    },
    maintainAspectRatio: false, // Vô hiệu hóa tỷ lệ khung hình
    responsive: true,
    scales: {
      x: {
        stacked: false, // Hiển thị các cột cạnh nhau
      },
      y: {
        title: {
          display: true,
          text: "Ngày", // Name of x-axis
        },
        beginAtZero: true,
        stacked: false,
        suggestedMax: 30, // Giá trị gợi ý tối đa
        ticks: {
          callback: function (value, index, values) {
            if (index === values.length - 1) {
              return `${value}`;
            }

            return value;
          },
        },
      },
    },
  };

  return (
    <>
      <Bar data={data} options={options} />
    </>
  );
};

const CombinedLegend = ({ datasets }) => {
  // Gộp tất cả labels & colors từ các datasets
  const legendItems = datasets.flatMap((dataset) =>
    dataset.labels.map((label, index) => ({
      label,
      color: dataset.datasets[0].backgroundColor[index],
    }))
  );

  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        marginTop: "10px",
        justifyContent: "center",
      }}
    >
      {legendItems.map((item, index) => (
        <div key={index} style={{ display: "flex", alignItems: "center" }}>
          <span
            style={{
              width: "12px",
              height: "12px",
              backgroundColor: item.color,
              display: "inline-block",
              marginRight: "5px",
            }}
          ></span>
          {item.label}
        </div>
      ))}
    </div>
  );
};

const CandidateSourceReport = ({ dataReport }) => {
  const generateLabels = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_candidate_source.length == 0) {
      return [];
    }
    const data_labels =
      dataReport.result_candidate_source.length > 0
        ? dataReport.result_candidate_source.map((item) =>
            item["candidate_source__name"] == null
              ? "Khác"
              : item["candidate_source__name"]
          )
        : [{}];

    return data_labels;
  };

  const data_cv_all = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_candidate_source.length == 0) {
      return [];
    }
    const value_labels = dataReport.result_candidate_source.map(
      (item) => item["number_cv_all"]
    );
    const value_colors = dataReport.result_candidate_source.map(
      (item) => item["candidate_source__color"]
    );

    return [value_labels, value_colors];
  };

  const data_number_cv_pass = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_candidate_source.length == 0) {
      return [];
    }
    const value_labels = dataReport.result_candidate_source.map(
      (item) => item["number_cv_pass"]
    );
    const value_colors = dataReport.result_candidate_source.map(
      (item) => item["candidate_source__color"]
    );
    return [value_labels, value_colors];
  };

  const data = {
    labels: generateLabels(dataReport),
    datasets: [
      {
        label: "Số lượng CV",
        data: data_cv_all(dataReport)[0],
        backgroundColor: data_cv_all(dataReport)[1],
        borderWidth: 1,
        barThickness: 35, // Độ dày cố định của cột
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false, // Hiển thị tên và màu chú thích
        position: "top",
        align: "end", // Căn về phía bên phải
      },
      centerText: {
        display: false, // Set to false to not display the center text
      },
      datalabels: {
        display: true,
        color: "#fff",
        font: {
          size: 15,
          weight: "bold",
        },
        label: "Số lượng ứng viên",

        formatter: (value, context) => {
          return value;
        },
      },
      title: {
        display: true,
        text: "Nguồn ứng viên - Số lượng CV",
        font: {
          size: 18,
          weight: "bold",
        },
        color: "#333",
      },
    },
    maintainAspectRatio: false, // Vô hiệu hóa tỷ lệ khung hình
    responsive: true,
  };

  const data_cv_pass = {
    labels: generateLabels(dataReport),
    datasets: [
      {
        label: "Số lượng đã nhận việc",
        data: data_number_cv_pass(dataReport)[0],
        backgroundColor: data_number_cv_pass(dataReport)[1],
        borderWidth: 1,
        barThickness: 35, // Độ dày cố định của cột
      },
    ],
  };

  const options_cv_pass = {
    plugins: {
      legend: {
        display: false, // Hiển thị tên và màu chú thích
        position: "top",
        align: "end", // Căn về phía bên phải
      },
      centerText: {
        display: false, // Set to false to not display the center text
      },
      datalabels: {
        display: true,
        color: "#fff",
        font: {
          size: 15,
          weight: "bold",
        },
        label: "Số lượng ứng viên",

        formatter: (value, context) => {
          return value;
        },
      },
      title: {
        display: true,
        text: "Nguồn ứng viên - Số lượng đã nhận việc",
        font: {
          size: 18,
          weight: "bold",
        },
        color: "#333",
      },
    },
    maintainAspectRatio: false, // Vô hiệu hóa tỷ lệ khung hình
    responsive: true,
  };

  const filteredData = {
    labels: data_cv_pass?.labels?.filter(
      (_, index) => data_cv_pass?.datasets[0]?.data[index] !== 0
    ),
    datasets: [
      {
        ...data_cv_pass?.datasets[0],
        data: data_cv_pass?.datasets[0]?.data?.filter((value) => value !== 0),
        backgroundColor: data_cv_pass?.datasets[0]?.backgroundColor?.filter(
          (_, index) => data_cv_pass?.datasets[0]?.data[index] !== 0
        ),
      },
    ],
  };

  return (
    <Row style={{ height: "400px" }}>
      <Col span={24}>
        <CombinedLegend datasets={[data]} />
      </Col>
      <Col span={12}>
        <Pie data={data} options={options} />
      </Col>
      <Col span={12}>
        <Pie data={filteredData} options={options_cv_pass} />
      </Col>
    </Row>
  );
};

const CVConversionRate = ({ dataReport }) => {
  const generateLabels = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_cv_conversion_rate.length == 0) {
      return [];
    }
    const data_labels = dataReport.result_cv_conversion_rate;
    return data_labels;
  };

  const generateColor = (dataReport) => {
    if (dataReport.length == 0) {
      return [];
    }
    if (dataReport.result_cv_conversion_rate.length == 0) {
      return [];
    }
    const data_color = dataReport.result_cv_conversion_rate.map(
      (item) => item.color
    );
    return data_color;
  };

  const config = {
    data: generateLabels(dataReport),
    xField: "name",
    yField: "number_cv",
    label: {
      // text: (d) => `${d.name}\n${d.number_cv}`,
      content: function content(d) {
        return d.number_cv;
      },
      style: {
        fontSize: 15,
      },
    },
    legend: {
      position: "top",
      itemName: {
        style: {
          fontSize: 14,
        },
      },
    },

    animation: false, // Tắt hoạt hình
    isTransposed: false, // Để phễu dọc
    maxSize: 1, // Tỷ lệ chiều rộng của phần trên cùng (đỉnh phễu)
    minSize: 0.3, // Tỷ lệ chiều rộng của phần nhỏ nhất (đáy phễu)
    funnelStyle: {
      stroke: "#fff", // Đường viền giữa các phần
      lineWidth: 1,
    },
    color: generateColor(dataReport), //[' #008ac6',' #ff8800', ' #21610B', ' #d4d400', ' #d352ca'], // Màu sắc từng phần
    conversionTag: {
      //Hiển thị tỷ lệ chuyển đổi giữa các giai đoạn.
      //   formatter: (data) => `${(data.$$percentage$$ * 100).toFixed(2)}%`,
      style: {
        fontWeight: "bold", // In đậm
      },
    },
  };

  return (
    <Row style={{ height: "100%" }}>
      <Col span={24}>
        <Funnel {...config} />
      </Col>
    </Row>
  );
};

const ReportRecruitment = ({
  dateNow,
  setRangeDate,
  loading,
  dataReport,
  onSearch,
  onClickFileDownload,
  loadingReport
}) => {
  const columns_rect = [
    {
      title: "STT",
      dataIndex: "id",
      key: "id",
      filterKey: "id",
      type: "text",
      sorter: (a, b) => a.id - b.id,
      render: (value) => value + 1,
      width: 50,
      align: "center",
    },
    {
      title: "Mã yêu cầu TD",
      dataIndex: "ticket_code",
      key: "ticket_code",
      filterKey: "ticket_code",
      type: "text",
      canSearch: true,
      width: 80,
    },
    {
      title: "Vị trí tuyển dụng",
      dataIndex: "rec_position",
      key: "rec_position",
      filterKey: "rec_position",
      type: "text",
      canSearch: true,
      width: 200,
    },
    {
      title: "Bộ phận tuyển dụng",
      dataIndex: "department_recruited",
      key: "department_recruited",
      filterKey: "department_recruited",
      type: "text",
      canSearch: true,
      width: 150,
    },
    {
      title: "Số lượng CV",
      dataIndex: "number_cv_all",
      key: "number_cv_all",
      type: "text",
      filterKey: "number_cv_all",
      canSearch: true,
      width: 100,
      align: "center",
      render: (value) => <div style={{ textAlign: "center" }}>{value}</div>,
    },
    {
      title: "Số lượng yêu cầu",
      dataIndex: "quantity",
      key: "quantity",
      type: "text",
      filterKey: "quantity",
      canSearch: true,
      width: 100,
      align: "center",
      render: (value) => <div style={{ textAlign: "center" }}>{value}</div>,
    },
    {
      title: "Số lượng đã nhận việc",
      dataIndex: "number_cv_pass",
      key: "number_cv_pass",
      type: "text",
      filterKey: "number_cv_pass",
      canSearch: true,
      width: 100,
      align: "center",
      render: (value) => <div style={{ textAlign: "center" }}>{value}</div>,
    },
    //  <Badge count={<QuestionOutlined style={{ color: '#f5222d' }} />}></Badge>
    {
      title: (
        <>
          Tỷ lệ hoàn thành
          <Tooltip_antd title="Số lượng đã nhận việc / Số lượng yêu cầu * 100%">
            <QuestionCircleOutlined style={{ marginLeft: 5 }} />
          </Tooltip_antd>
        </>
      ),
      dataIndex: "rate_pass",
      key: "rate_pass",
      type: "text",
      filterKey: "rate_pass",
      width: 100,
      canSearch: true,
      align: "center",
      render: (value) => (
        <div style={{ textAlign: "center" }}>{value + "%"}</div>
      ),
    },
  ];

  const columns_department = [
    {
      title: "STT",
      dataIndex: "id",
      key: "id",
      filterKey: "id",
      type: "text",
      sorter: (a, b) => a.id - b.id,
      render: (value) => value + 1,
      width: 50,
      align: "center",
    },
    {
      title: "Bộ phận tuyển dụng",
      dataIndex: "department_recruited",
      key: "department_recruited",
      filterKey: "department_recruited",
      type: "text",
      canSearch: true,
      width: 200,
    },
    {
      title: "Số lượng CV",
      dataIndex: "number_cv_all",
      key: "number_cv_all",
      type: "text",
      filterKey: "number_cv_all",
      canSearch: true,
      width: 100,
      align: "center",
      render: (value) => <div style={{ textAlign: "center" }}>{value}</div>,
    },
    {
      title: "Số lượng yêu cầu",
      dataIndex: "quantity",
      key: "quantity",
      type: "text",
      filterKey: "quantity",
      canSearch: true,
      width: 100,
      align: "center",
      render: (value) => <div style={{ textAlign: "center" }}>{value}</div>,
    },
    {
      title: "Số lượng đã nhận việc",
      dataIndex: "number_cv_pass",
      key: "number_cv_pass",
      type: "text",
      filterKey: "number_cv_pass",
      canSearch: true,
      width: 100,
      align: "center",
      render: (value) => <div style={{ textAlign: "center" }}>{value}</div>,
    },
    //  <Badge count={<QuestionOutlined style={{ color: '#f5222d' }} />}></Badge>
    {
      title: (
        <>
          Tỷ lệ hoàn thành
          <Tooltip_antd title="Số lượng đã nhận việc / Số lượng yêu cầu * 100%">
            <QuestionCircleOutlined style={{ marginLeft: 5 }} />
          </Tooltip_antd>
        </>
      ),
      dataIndex: "rate_pass",
      key: "rate_pass",
      type: "text",
      filterKey: "rate_pass",
      width: 100,
      canSearch: true,
      align: "center",
      render: (value) => (
        <div style={{ textAlign: "center" }}>{value + "%"}</div>
      ),
    },
  ];

  const columns_hr = [
    {
      title: "STT",
      dataIndex: "id",
      key: "id",
      filterKey: "id",
      type: "text",
      sorter: (a, b) => a.id - b.id,
      render: (value) => value + 1,
      width: 50,
      align: "center",
    },
    {
      title: "Người phụ trách",
      dataIndex: "username",
      key: "username",
      filterKey: "username",
      type: "text",
      canSearch: true,
      width: 200,
    },
    {
      title: "Số lượng CV",
      dataIndex: "number_cv_all",
      key: "number_cv_all",
      type: "text",
      filterKey: "number_cv_all",
      canSearch: true,
      width: 100,
      align: "center",
      render: (value) => <div style={{ textAlign: "center" }}>{value}</div>,
    },
    {
      title: "Số lượng yêu cầu",
      dataIndex: "quantity",
      key: "quantity",
      type: "text",
      filterKey: "quantity",
      canSearch: true,
      width: 100,
      align: "center",
      render: (value) => <div style={{ textAlign: "center" }}>{value}</div>,
    },
    {
      title: "Số lượng đã nhận việc",
      dataIndex: "number_cv_pass",
      key: "number_cv_pass",
      type: "text",
      filterKey: "number_cv_pass",
      canSearch: true,
      width: 100,
      align: "center",
      render: (value) => <div style={{ textAlign: "center" }}>{value}</div>,
    },
    {
      title: (
        <>
          Tỷ lệ hoàn thành
          <Tooltip_antd title="Số lượng nhận việc / Số lượng yêu cầu * 100%">
            <QuestionCircleOutlined style={{ marginLeft: 5 }} />
          </Tooltip_antd>
        </>
      ),
      dataIndex: "rate_pass",
      key: "rate_pass",
      type: "text",
      filterKey: "rate_pass",
      width: 100,
      canSearch: true,
      align: "center",
      render: (value) => (
        <div style={{ textAlign: "center" }}>{value + "%"}</div>
      ),
    },
  ];

  const columns_candidate_source = [
    {
      title: "STT",
      dataIndex: "id",
      key: "id",
      filterKey: "id",
      type: "text",
      sorter: (a, b) => a.id - b.id,
      render: (value) => value + 1,
      width: 50,
      align: "center",
    },
    {
      title: "Nguồn ứng viên",
      dataIndex: "candidate_source__name",
      key: "candidate_source__name",
      filterKey: "candidate_source__name",
      type: "text",
      canSearch: true,
      width: 200,
      render: (value) => (value == null ? "Khác (CV không điền)" : value),
    },
    {
      title: "Số lượng CV",
      dataIndex: "number_cv_all",
      key: "number_cv_all",
      type: "text",
      filterKey: "number_cv_all",
      canSearch: true,
      width: 100,
      align: "center",
      render: (value) => <div style={{ textAlign: "center" }}>{value}</div>,
    },
    {
      title: "Số lượng đã nhận việc",
      dataIndex: "number_cv_pass",
      key: "number_cv_pass",
      type: "text",
      filterKey: "number_cv_pass",
      canSearch: true,
      width: 100,
      align: "center",
      render: (value) => <div style={{ textAlign: "center" }}>{value}</div>,
    },
  ];

  const columns_time_recruitment = [
    {
      title: "STT",
      dataIndex: "id",
      key: "id",
      filterKey: "id",
      type: "text",
      sorter: (a, b) => a.id - b.id,
      render: (value) => value + 1,
      width: 50,
      align: "center",
    },
    {
      title: "Mã yêu cầu TD",
      dataIndex: "ticket_code",
      key: "ticket_code",
      filterKey: "ticket_code",
      type: "text",
      canSearch: true,
      width: 80,
    },
    {
      title: "Vị trí tuyển dụng",
      dataIndex: "rec_position",
      key: "rec_position",
      filterKey: "rec_position",
      type: "text",
      canSearch: true,
      width: 200,
    },
    {
      title: "Ngày tạo",
      dataIndex: "created",
      key: "created",
      filterKey: "created",
      type: "text",
      canSearch: true,
      width: 100,
      align: "center",
      render: (text, record) => moment(text).format("L HH:mm"),
    },
    {
      title: (
        <>
          Ngày đóng
          <Tooltip_antd title="Ticket ở trạng thái Đóng">
            <QuestionCircleOutlined style={{ marginLeft: 5 }} />
          </Tooltip_antd>
        </>
      ),
      dataIndex: "time_close",
      key: "time_close",
      filterKey: "time_close",
      type: "text",
      canSearch: true,
      width: 100,
      align: "center",
      render: (text, record) =>
        text != null ? moment(text).format("L HH:mm") : null,
    },
    {
      title: (
        <>
          Trung bình tuyển dụng
          <Tooltip_antd title="(Ngày đóng ticket - Ngày tạo ticket) / Số lượng CV Đã nhận việc">
            <QuestionCircleOutlined style={{ marginLeft: 5 }} />
          </Tooltip_antd>
        </>
      ),
      dataIndex: "rate_pass",
      key: "rate_pass",
      filterKey: "rate_pass",
      type: "text",
      canSearch: true,
      width: 100,
      align: "center",
      render: (value) => (
        <div style={{ textAlign: "center" }}>{value + " Ngày"}</div>
      ),
    },
  ];

  return (
    <Row>
      {/* <Col span={24}>
        <h1
          style={{
            fontSize: 20,
            fontWeight: 700,
            width: "100%",
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          Kết quả tuyển dụng
        </h1>
      </Col> */}
      <Col span={24}>
        <RangePicker
          ranges={{
            "Hôm nay": [moment(), moment()],
            "Tháng này": [moment().startOf("month"), moment().endOf("month")],
            "Năm nay": [moment().startOf("year"), moment().endOf("year")],
            "Năm ngoái": [
              moment().add(-1, "year").startOf("year"),
              moment().add(-1, "year").endOf("year"),
            ],
          }}
          format="DD/MM/YYYY"
          value={dateNow}
          onChange={(e, value) => setRangeDate(value)}
          allowClear={false}
        />
        <Button
          type={"primary"}
          style={{ marginLeft: 5 }}
          onClick={() => onSearch()}
          className={"big-icon"}
          icon={<SearchOutlined />}
        >
          Tra cứu
        </Button>

        <Button
          type={"primary"}
          className={"btnGreen big-icon"}
          style={{ marginLeft: 5 }}
          onClick={onClickFileDownload}
          icon={<DownloadOutlined />}
          loading={loadingReport}
        >
          Xuất excel
        </Button>
      </Col>
      <Spin spinning={loading} wrapperClassName={"styleSpin-ReportRect"}>
        <div
          style={{
            height: "80vh",
            overflow: "scroll",
            backgroundColor: "#fff",
            marginTop: "5px",
          }}
        >
          <div style={{ padding: "1%", display: "grid", rowGap: "2ch" }}>
            <Row style={{ border: "1px solid #d1d1d1" }}>
              <Col span={24}>
                <Card
                  bodyStyle={{
                    paddingTop: "12px",
                    paddingBottom: "0px",
                    height: "40vh",
                    textAlign: "center",
                  }}
                >
                  {/* <h1>
                    <b>Vị trí tuyển dụng</b>
                  </h1> */}
                  <PositionRecruitment dataReport={dataReport} />
                </Card>
              </Col>
              <Col span={24}>
                <Table
                  dataSource={dataReport.result_rect}
                  columns={columns_rect}
                  loading={loading}
                  bordered={true}
                  rowKey="id"
                  scroll={{ x: 500, y: "30dvh" }}
                  size="small"
                  className="styleTable_1"
                  pagination={false}
                  style={{ maxHeight: "30dvh" }}
                />
              </Col>
            </Row>
            <br></br>
            <Row style={{ border: "1px solid #d1d1d1" }}>
              <Col span={24}>
                <Card
                  bodyStyle={{
                    paddingTop: "12px",
                    paddingBottom: "0px",
                    height: "40vh",
                    textAlign: "center",
                  }}
                >
                  <DepartmentRecruitment dataReport={dataReport} />
                </Card>
              </Col>
              <Col span={24}>
                <Table
                  dataSource={dataReport.result_department}
                  columns={columns_department}
                  loading={loading}
                  bordered={true}
                  rowKey="id"
                  scroll={{ x: 500, y: "30dvh" }}
                  size="small"
                  className="styleTable_1"
                  pagination={false}
                  style={{ maxHeight: "30dvh" }}
                />
              </Col>
            </Row>
            <br></br>
            <Row style={{ border: "1px solid #d1d1d1" }}>
              <Col span={24}>
                <Card
                  bodyStyle={{
                    paddingTop: "12px",
                    paddingBottom: "0px",
                    height: "40vh",
                    textAlign: "center",
                  }}
                >
                  <UserReceivedRecruitment dataReport={dataReport} />
                </Card>
              </Col>
              <Col span={24}>
                <Table
                  dataSource={dataReport.result_hr}
                  columns={columns_hr}
                  loading={loading}
                  bordered={true}
                  rowKey="id"
                  scroll={{ x: 500, y: "30dvh" }}
                  size="small"
                  className="styleTable_1"
                  pagination={false}
                  style={{ maxHeight: "30dvh" }}
                />
              </Col>
            </Row>
            <br></br>
            <Row style={{ border: "1px solid #d1d1d1" }}>
              <Col span={24}>
                <Card
                  bodyStyle={{
                    paddingTop: "12px",
                    paddingBottom: "0px",
                    height: "40vh",
                    textAlign: "center",
                  }}
                >
                  <TimeRecruitment dataReport={dataReport} />
                </Card>
              </Col>
              <Col span={24}>
                <Table
                  dataSource={dataReport.result_time_recruitment}
                  columns={columns_time_recruitment}
                  loading={loading}
                  bordered={true}
                  rowKey="id"
                  scroll={{ x: 500, y: "30dvh" }}
                  size="small"
                  className="styleTable_1"
                  pagination={false}
                  style={{ maxHeight: "30dvh" }}
                />
              </Col>
            </Row>
            <br></br>
            <Row style={{ border: "1px solid #d1d1d1" }}>
              <Col span={24}>
                <Card
                  bodyStyle={{
                    paddingTop: "12px",
                    paddingBottom: "0px",
                    height: "440px",
                    textAlign: "center",
                  }}
                >
                  <CandidateSourceReport dataReport={dataReport} />
                </Card>
              </Col>
              <Col span={24}>
                <Table
                  dataSource={dataReport.result_candidate_source}
                  columns={columns_candidate_source}
                  loading={loading}
                  bordered={true}
                  rowKey="id"
                  scroll={{ x: 500, y: "30dvh" }}
                  size="small"
                  className="styleTable_1"
                  pagination={false}
                  style={{ maxHeight: "30dvh" }}
                />
              </Col>
            </Row>
            <br></br>
            <Row style={{ border: "1px solid #d1d1d1" }}>
              <Col span={12} offset={6}>
                <Card
                  bodyStyle={{
                    paddingTop: "12px",
                    paddingBottom: "0px",
                    height: "45vh",
                    textAlign: "center",
                  }}
                  className="card-report"
                >
                  <h3
                    style={{
                      fontSize: "19px",
                      fontWeight: "bold",
                      // marginBottom: "10px",
                    }}
                  >
                    Tỷ lệ chuyển đổi ứng viên
                  </h3>
                  <CVConversionRate dataReport={dataReport} />
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </Spin>
    </Row>
  );
};

export default ReportRecruitment;
